module.exports = __webpack_public_path__ + "img/cloud_1.0f540acf.png";